export function getNodesByName(name) {
    return abp.ajax({
        url: '/api/services/app/Node/GetNodesByName',
        method: 'get',
        params: { name: name }
    });
}
